<template>
  <div class="row documento_dados">
    <div class="small-12 medium-12 large-12 columns">
      <div class="row">
        <div class="small-4 medium-4 large-4 columns ano_doc_legislacao">
          <h3 class="ano">{{ item.data }}</h3>
        </div>
        <div class="small-8 medium-8 large-8 columns">
          <h3>{{ item.titulo }}</h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["item"],
}
</script>

<style lang="scss" scoped>
.row .row,
.documento_dados {
  margin-right: 0px;
  margin-left: 0px;
}

.documento_dados:hover{
  cursor: pointer;
}

.documento_dados {
  border-bottom: 1px solid #a7a5a5;
}

.documento_dados .columns {
  padding-left: 0;
  padding-right: 0;
}

.documento_dados .columns .columns {
  padding-right: 7px;
  padding-top: 7px;
  padding-bottom: 7px;
  padding-left: 0;
}

h3 {
  font-family: "Montserrat";
  font-size: 15px;
  padding-top: 14px;
  color: #707475;
  padding-right: 20px;
}

h3.ano {
  font-family: "Montserrat Bold";
  color: #707475;
  font-size: 15px;
  padding-top: 14px;
  padding-right: 20px;
  padding-left: 0;
}

.documento_dados .columns .columns.othercolumn {
  padding-right: 0;
}

.img_icon_doc a img {
  width: 28px;
}

.descarregar_doc a {
  padding-left: 5px;
  display: block;
  padding-top: 7px;
  font-family: "Montserrat Bold";
  color: #707475;
  font-size: 15px;
}

.descarregar_doc a:visited {
  color: #707475 !important;
}

@media (max-width : 1024px){

  .documento_dados h3{
    font-size: 14px;
  }

}

@media screen and (max-width:767px) {
  .img_icon_doc a img {
    width: 25px;
  }
  .descarregar_doc a {
    padding-top: 5px;
    font-family: "Montserrat Bold";
    color: #707475;
    font-size: 14px;
    margin-left: 0;
    margin-bottom: -5px;
  }

  .documento_dados .columns .columns{
    padding-bottom: 0;
  }

  .documento_dados {
    border-bottom: transparent;
  }

  .documento_dados h3{
    padding-top: 6px;
    padding-right: 0;
    line-height: 1.6;
  }
  
}
</style>